import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { DialogComponent } from "../../../components/dialog/DialogComponent";
import Http from "../../../Http";
import Snackbar from "../../../components/alert/Snackbar";
import DescargarNota from "./DescargarNota";
import ACCESS from "../../../ACCESS.js";
// import Factura from "./PagoFacturas";

class NotasCredito extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `nota-credito/filter`,
        deleteUrl: "nota-credito/delete",
        deleteField: "id",
        modUrl: "/cobranza/nota-credito",
      },
      TableOp.Table(
        false,
        [
          { label: "Folio", id: "id" },
          { label: "Importe", id: "importe" },
          { label: "Fecha", id: "createdAt" },
          { label: "Cliente", id: "cliente" },
          { label: "Timbrada", id: "timbrado_s" },
          { label: "Cancelada", id: "cancelada_s" },
          { label: "F. Fiscal", id: "fiscal" },
        ],
        [
          { id: "edit", icon: "edit", access: [ACCESS.COBRANZA_NOTA_CREDITO.VER_NOTAS_CREADAS_POR_EL_USUARIO, ACCESS.COBRANZA_NOTA_CREDITO.VER_TODAS_NOTAS_CREDITO] },
          { id: 'cancel', icon: 'cancel', tooltip: 'Cancelar Nota Credito', access: [ACCESS.COBRANZA_NOTA_CREDITO.CANCELAR_NOTA_DE_CREDITO] },
          { id: "files", icon: "mail", tooltip: "Descargar archivos", access: [ACCESS.COBRANZA_NOTA_CREDITO.DESCARGAR_ARCHIVOS] },
          // { id: 'delete', icon: 'delete' },
        ]
      )
    );
    this.table();
  }

  action = (id, row, cb) => {
		if (id === 'edit') {
			this.props.history.push(`${this.config.modUrl}/${row.id}`)
		} else if (id === 'files')  {
      this.setState({
        viewPdf: true,
        nota: row,
      })
    } else if (id === 'cancel') {
      this.cancelarFactura(id, row)
    }
	}

  toNote = () => {
    this.props.history.push('/cobranza/nota-credito/');
  }

  cancelarFactura = (id, row) => {
    this.setState({ cancelDialog: { visible: true, row } });
  }

  onClose = async (op) => {
    console.log(op);
    if (!op) return this.setState({ cancelDialog: { visible: false } });
    const { cancelDialog } = this.state;
    this.setState({ cancelDialog: { ...cancelDialog, loading: true } });
    try {
      let Res = await Http.post(`nota-credito/${cancelDialog.row.id}/cancelar`);
      if (!Res.error) {
        Snackbar('Nota de crédito cancelada');
        this.table();
      }
      else {
        Snackbar(`Error al cancelar: ${Res.errMsg}`);
      }
      this.setState({ cancelDialog: { visible: false } });
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    const { cancelDialog = {} } = this.state;
    const { viewPdf = false, nota = {} } = this.state;
    const { hasAccess } = this.context;
    return (
      <div className="row">
        <div className="col-sm-12" style={{ textAlign: 'right' }}>
          {
            hasAccess(ACCESS.COBRANZA_NOTA_CREDITO.CREAR_NOTA_DE_CREDITO) &&
            <Button onClick={this.toNote} variant="contained" color="primary">
              Nueva nota
            </Button>
          }
        </div>
        <div className="col-sm-12">
          <this.TableRender />

          <Dialog
            fullWidth={true}
            maxWidth={"xl"}
            open={viewPdf}
            onClose={() => { this.setState({ viewPdf: false }) }}
          // onClick={() => this.reenviarFacturaClose(false)}
          >
          <DialogTitle>Nota Credito</DialogTitle>
          <DialogContent>
            <DescargarNota nota={nota} />
          </DialogContent>
        </Dialog>
        </div>

        <DialogComponent
          open={cancelDialog.visible}
          title={"Confirmar"}
          options={["Sí, cancelar"]}
          onClose={this.onClose}
          loading={cancelDialog.loading}
        >
          ¿Cancelar nota de crédito?
        </DialogComponent>
      </div>
    );
  }
}

export default withRouter(NotasCredito);